var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdamantineRock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 148.62 131.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#_1248-4);}.cls-2{fill:url(#_1248-3);}.cls-3{fill:url(#_1248-2);}.cls-4{fill:url(#_1321-3);}.cls-5{fill:url(#_1321-4);}.cls-6{fill:url(#_1321-2);}.cls-7{fill:url(#_1321-6);}.cls-8{fill:url(#_1321-5);}.cls-9{fill:url(#_236-12);}.cls-10{fill:url(#_236-11);}.cls-11{fill:url(#_236-16);}.cls-12{fill:url(#_236-10);}.cls-13{fill:url(#_236-15);}.cls-14{fill:url(#_236-14);}.cls-15{fill:url(#_236-13);}.cls-16{fill:url(#linear-gradient);}.cls-17{fill:url(#_127-2);}.cls-17,.cls-18,.cls-19{mix-blend-mode:color-dodge;}.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30{opacity:.5;}.cls-18{fill:url(#_127-3);}.cls-31{fill:url(#_236);}.cls-19{fill:url(#_127);}.cls-32{fill:url(#_1321);}.cls-33{fill:url(#_1248);}.cls-34{fill:url(#New_Gradient_Swatch_5);}.cls-20{fill:url(#New_Gradient_Swatch_1);}.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30{mix-blend-mode:multiply;}.cls-35{fill:url(#linear-gradient-8);}.cls-36{fill:url(#linear-gradient-9);}.cls-37{fill:url(#linear-gradient-3);}.cls-38{fill:url(#linear-gradient-4);}.cls-39{fill:url(#linear-gradient-2);}.cls-40{fill:url(#linear-gradient-6);}.cls-41{fill:url(#linear-gradient-7);}.cls-42{fill:url(#linear-gradient-5);}.cls-21{fill:url(#New_Gradient_Swatch_1-10);}.cls-22{fill:url(#New_Gradient_Swatch_1-11);}.cls-23{fill:url(#New_Gradient_Swatch_1-6);}.cls-24{fill:url(#New_Gradient_Swatch_1-9);}.cls-25{fill:url(#New_Gradient_Swatch_1-7);}.cls-26{fill:url(#New_Gradient_Swatch_1-4);}.cls-27{fill:url(#New_Gradient_Swatch_1-3);}.cls-28{fill:url(#New_Gradient_Swatch_1-8);}.cls-29{fill:url(#New_Gradient_Swatch_1-5);}.cls-30{fill:url(#New_Gradient_Swatch_1-2);}.cls-43{fill:url(#linear-gradient-14);}.cls-44{fill:url(#linear-gradient-13);}.cls-45{fill:url(#linear-gradient-12);}.cls-46{fill:url(#linear-gradient-10);}.cls-47{fill:url(#linear-gradient-11);}.cls-48{isolation:isolate;}.cls-49{fill:url(#_236-9);}.cls-50{fill:url(#_236-7);}.cls-51{fill:url(#_236-6);}.cls-52{fill:url(#_236-5);}.cls-53{fill:url(#_236-4);}.cls-54{fill:url(#_236-8);}.cls-55{fill:url(#_236-3);}.cls-56{fill:url(#_236-2);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_5",
    cx: 70.88,
    cy: 68.65,
    fx: -0.51,
    fy: 6.82,
    r: 110.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#f1eff1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#c7c2ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#a198a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#817587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#66576e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#503e59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3e2c48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#331e3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2c1736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a1535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236",
    x1: 74.31,
    y1: 0,
    x2: 74.31,
    y2: 131.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9e0ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98aad2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    x1: 74.31,
    y1: 83.91,
    x2: 74.31,
    y2: 131.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7d7cba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a5ba4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-2",
    x1: 74.31,
    y1: 129.92,
    x2: 74.31,
    y2: 1.93,
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_127",
    x1: 74.31,
    y1: -3960.5,
    x2: 74.31,
    y2: -3912.56,
    gradientTransform: "translate(0 -3912.56) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7d7cba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#acbcdd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-2",
    x1: 23.79,
    y1: 64.8,
    x2: 23.79,
    y2: 86.3,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321",
    x1: -6210.82,
    y1: 687.63,
    x2: -6210.82,
    y2: 667.64,
    gradientTransform: "translate(-2311.78 5819.3) rotate(118.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85769c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#98aad2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9e0ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-3",
    x1: -6208.37,
    y1: 665.8,
    x2: -6208.37,
    y2: 683.53,
    gradientTransform: "translate(-2311.78 5819.3) rotate(118.16)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-4",
    x1: -6224.58,
    y1: 670.32,
    x2: -6224.58,
    y2: 676.67,
    gradientTransform: "translate(-2311.78 5819.3) rotate(118.16)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_127-2",
    x1: -6229.99,
    y1: 678.85,
    x2: -6229.99,
    y2: 673.6,
    gradientTransform: "translate(-2311.78 5819.3) rotate(118.16)",
    xlinkHref: "#_127"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1248",
    x1: -6225.68,
    y1: 658.93,
    x2: -6225.68,
    y2: 665.47,
    gradientTransform: "translate(-2311.78 5819.3) rotate(118.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a5ba4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1f3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-3",
    x1: -6195.13,
    y1: 673.6,
    x2: -6195.13,
    y2: 672.06,
    gradientTransform: "translate(-2311.78 5819.3) rotate(118.16)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-5",
    x1: 4.83,
    y1: 57.22,
    x2: 0.44,
    y2: 65.9,
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-2",
    x1: -10602.16,
    y1: 3037.94,
    x2: -10602.16,
    y2: 3017.95,
    gradientTransform: "translate(-2311.78 -10668.41) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-6",
    x1: -10599.7,
    y1: 3016.11,
    x2: -10599.7,
    y2: 3033.84,
    gradientTransform: "translate(-2311.78 -10668.41) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-7",
    x1: -10615.92,
    y1: 3020.49,
    x2: -10615.92,
    y2: 3027.02,
    gradientTransform: "translate(-2311.78 -10668.41) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-8",
    x1: -10621.32,
    y1: 3029.17,
    x2: -10621.32,
    y2: 3023.91,
    gradientTransform: "translate(-2311.78 -10668.41) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1248-2",
    x1: -10616.62,
    y1: 3009.71,
    x2: -10616.62,
    y2: 3016.12,
    gradientTransform: "translate(-2311.78 -10668.41) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_1248"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-4",
    x1: -10586.47,
    y1: 3023.91,
    x2: -10586.47,
    y2: 3022.38,
    gradientTransform: "translate(-2311.78 -10668.41) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-9",
    x1: -0.18,
    y1: 81.87,
    x2: 5.98,
    y2: 77.39,
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-3",
    x1: 19.46,
    y1: 71.54,
    x2: 3.04,
    y2: 59.97,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-5",
    x1: 10.82,
    y1: 58.22,
    x2: 10.82,
    y2: 72.25,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-6",
    x1: 10.82,
    y1: 21.03,
    x2: 10.82,
    y2: 35.06,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-7",
    x1: -4986.48,
    y1: 64.8,
    x2: -4986.48,
    y2: 86.3,
    gradientTransform: "translate(-4861.64) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-4",
    x1: -3846.67,
    y1: 5104.81,
    x2: -3846.67,
    y2: 5084.82,
    gradientTransform: "translate(-2549.86 5819.3) rotate(61.84) scale(1 -1)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-10",
    x1: -3844.22,
    y1: 5082.98,
    x2: -3844.22,
    y2: 5100.71,
    gradientTransform: "translate(-2549.86 5819.3) rotate(61.84) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-11",
    x1: -3860.44,
    y1: 5087.5,
    x2: -3860.44,
    y2: 5093.85,
    gradientTransform: "translate(-2549.86 5819.3) rotate(61.84) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_127-3",
    x1: -3865.84,
    y1: 5096.03,
    x2: -3865.84,
    y2: 5090.78,
    gradientTransform: "translate(-2549.86 5819.3) rotate(61.84) scale(1 -1)",
    xlinkHref: "#_127"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1248-3",
    x1: 95.21,
    y1: 18.66,
    x2: 118.73,
    y2: 12.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#_1248"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-8",
    x1: -3830.99,
    y1: 5090.78,
    x2: -3830.99,
    y2: 5089.24,
    gradientTransform: "translate(-2549.86 5819.3) rotate(61.84) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-12",
    x1: -5005.44,
    y1: 57.22,
    x2: -5009.82,
    y2: 65.9,
    gradientTransform: "translate(-4861.64) rotate(-180) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-5",
    x1: -8238.01,
    y1: 7455.12,
    x2: -8238.01,
    y2: 7435.13,
    gradientTransform: "translate(-2549.86 -10668.41) rotate(-61.84)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-13",
    x1: -8235.56,
    y1: 7433.29,
    x2: -8235.56,
    y2: 7451.02,
    gradientTransform: "translate(-2549.86 -10668.41) rotate(-61.84)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-14",
    x1: -8251.77,
    y1: 7437.67,
    x2: -8251.77,
    y2: 7444.2,
    gradientTransform: "translate(-2549.86 -10668.41) rotate(-61.84)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-15",
    x1: -8257.18,
    y1: 7446.35,
    x2: -8257.18,
    y2: 7441.09,
    gradientTransform: "translate(-2549.86 -10668.41) rotate(-61.84)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1248-4",
    x1: -8252.48,
    y1: 7426.89,
    x2: -8252.48,
    y2: 7433.3,
    gradientTransform: "translate(-2549.86 -10668.41) rotate(-61.84)",
    xlinkHref: "#_1248"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-9",
    x1: -8222.32,
    y1: 7441.09,
    x2: -8222.32,
    y2: 7439.56,
    gradientTransform: "translate(-2549.86 -10668.41) rotate(-61.84)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-16",
    x1: -5010.45,
    y1: 81.87,
    x2: -5004.29,
    y2: 77.39,
    gradientTransform: "translate(-4861.64) rotate(-180) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-6",
    x1: -4990.8,
    y1: 71.54,
    x2: -5007.23,
    y2: 59.97,
    gradientTransform: "translate(-4861.64) rotate(-180) scale(1 -1)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-10",
    x1: -4999.45,
    y1: 58.22,
    x2: -4999.45,
    y2: 72.25,
    gradientTransform: "translate(-4861.64) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-11",
    x1: -4999.45,
    y1: 21.03,
    x2: -4999.45,
    y2: 35.06,
    gradientTransform: "translate(-4861.64) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 31.38,
    y1: 77.34,
    x2: 48.24,
    y2: 77.34,
    gradientTransform: "translate(66.35 -5.5) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa6415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7a813"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 45.52,
    y1: 84.29,
    x2: 49.66,
    y2: 84.29,
    gradientTransform: "translate(73.54 -8.96) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 49.08,
    y1: 80.24,
    x2: 57.18,
    y2: 80.24,
    gradientTransform: "translate(72.3 -14.06) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 49.15,
    y1: 92.13,
    x2: 67.51,
    y2: 92.13,
    gradientTransform: "translate(82.23 -14.26) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 69.52,
    y1: 90.3,
    x2: 78.14,
    y2: 90.3,
    gradientTransform: "translate(85.48 -25.76) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 63.13,
    y1: 100.07,
    x2: 74.69,
    y2: 100.07,
    gradientTransform: "translate(90.94 -19.42) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 63.2,
    y1: 80.69,
    x2: 69.78,
    y2: 80.69,
    gradientTransform: "translate(76.53 -23.38) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 65.5,
    y1: 112.15,
    x2: 83.74,
    y2: 112.15,
    gradientTransform: "translate(101.16 -19.92) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 79.24,
    y1: 101.31,
    x2: 84.93,
    y2: 101.31,
    gradientTransform: "translate(95.68 -28.37) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 83.52,
    y1: 95.2,
    x2: 100.38,
    y2: 95.2,
    gradientTransform: "translate(94.25 -37.14) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 97.61,
    y1: 86.24,
    x2: 105.31,
    y2: 86.24,
    gradientTransform: "translate(90.7 -46.48) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 101.84,
    y1: 77.85,
    x2: 107.61,
    y2: 77.85,
    gradientTransform: "translate(85.72 -51.25) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 77.98,
    y1: 85.13,
    x2: 89.41,
    y2: 85.13,
    gradientTransform: "translate(84.71 -34.25) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 21.36,
    y1: 48.33,
    x2: 128.92,
    y2: 48.33,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 74.83,
    cy: 66.36,
    r: 63.55
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m74.32,0C37.9,0,8.39,29.52,8.39,65.93s29.52,65.93,65.93,65.93,65.93-29.52,65.93-65.93S110.73,0,74.32,0Zm0,128.16c-16.62,0-32.25-6.47-44-18.23-11.76-11.76-18.23-27.38-18.23-44.01s6.47-32.25,18.23-44C42.06,10.17,57.69,3.69,74.32,3.69s32.25,6.47,44,18.23c11.76,11.76,18.23,27.38,18.23,44s-6.47,32.25-18.23,44.01c-11.75,11.75-27.38,18.23-44,18.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m74.32,130.05c-29.77,0-54.97-19.4-63.44-46.14,7.83,27.67,33.27,47.94,63.44,47.94s55.61-20.27,63.44-47.94c-8.48,26.74-33.67,46.14-63.44,46.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m119.57,20.67C107.48,8.58,91.41,1.93,74.32,1.93s-33.16,6.66-45.25,18.75c-12.09,12.09-18.74,28.16-18.74,45.25s6.66,33.16,18.74,45.25c12.09,12.09,28.16,18.74,45.25,18.74s33.17-6.66,45.25-18.74c12.09-12.09,18.74-28.16,18.74-45.25s-6.66-33.17-18.74-45.25Zm-1.25,89.26c-11.75,11.75-27.38,18.23-44,18.23s-32.25-6.47-44-18.23c-11.76-11.76-18.23-27.38-18.23-44.01s6.47-32.25,18.23-44C42.06,10.17,57.69,3.69,74.32,3.69s32.25,6.47,44,18.23c11.76,11.76,18.23,27.38,18.23,44s-6.47,32.25-18.23,44.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m137.76,47.94C129.93,20.27,104.49,0,74.32,0S18.7,20.27,10.87,47.94C19.35,21.2,44.55,1.99,74.32,1.99s54.97,19.21,63.44,45.95Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m21.11,98.93l1.72,5.03s.43,1.37-.28,2.8l3.93,4.53-.52-6.18-4.85-6.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.96,18.03c-2.91,9.79-7.21,17.51-7.21,17.51-.98,2.17-2.33,5.08-2.33,5.08-.57,1.24-1.56,3.84-1.56,3.84,2.82-3.12,4.66-5.85,6.82-8.67,4.17-5.45,7.01-15.06,8.4-20.66.65-2.63.99-4.37.99-4.37,2.42-1.17,3.7-1.9,3.85-1.98.22-.11.45-.21.67-.31-.99-1.3-2.2-2.27-2.2-2.27-3.74-.56-5.28,1.48-5.28,1.48-.23,1.88-.54,3.7-.91,5.44-.37,1.72-.79,3.36-1.26,4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m17.43,40.62s2.11-4.66,2.25-4.9c0,0,4.38-7.9,7.29-17.69.46-1.56.89-3.2,1.26-4.91,0,0,.75,13.06-10.79,27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m31.39,15.89s-.45.46-1.8,4.68c0,0,.46-5.89,1.99-10.6,0,0,1.6-2.99,2.85-3.75.19.16,1.72,1.19,3.97,4.41-.22.1-.91.64-1.13.75-.15.09-2.43,1.73-5.88,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m29.13,7.68s1.33-1.77,4.52-1.57c-1.36,1.86-3.95,2.3-4.52,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m31.39,15.89l.97-2.77c1.29-1.73,2.77-2.63,2.77-2.63,0,0,1.31.19,2.57.62l-.42.28c-3.05,2.01-5.88,4.51-5.88,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m18.15,41.78s.83-2.07,1.43-3.99l.85-3.5c-.12.15-.52,1.06-.67,1.24-1.61,3.22-2.54,5.26-3.89,8.92,0,0,1.64-1.96,2.28-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m10.32,50.03s-4.56,4.81-7.29,15.9H0s.72-12.21,12.37-22.62l-2.05,6.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m26.96,113.82c-2.91-9.79-7.21-17.51-7.21-17.51-.98-2.17-2.33-5.08-2.33-5.08-.57-1.24-1.56-3.84-1.56-3.84,2.82,3.12,4.66,5.85,6.82,8.67,4.17,5.45,7.01,15.06,8.4,20.66.65,2.63.99,4.37.99,4.37,2.42,1.17,3.7,1.9,3.85,1.98.22.11.45.21.67.31-.99,1.3-2.2,2.27-2.2,2.27-3.74.56-5.28-1.48-5.28-1.48-.23-1.88-.54-3.7-.91-5.44-.37-1.72-.79-3.36-1.26-4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m17.43,91.24s2.11,4.66,2.25,4.9c0,0,4.38,7.9,7.29,17.69.46,1.56.89,3.2,1.26,4.91,0,0,.75-13.06-10.79-27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m31.05,115.61s-.11-.11-1.46-4.33c0,0,.46,5.89,1.99,10.6,0,0,1.6,2.99,2.85,3.75.19-.16,3.4-3.02,4.3-4.2-.22-.1-1.69-1.17-1.91-1.28-.15-.09-2.9-1.86-5.77-4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m29.13,124.17s1.33,1.77,4.52,1.57c-1.36-1.86-3.95-2.3-4.52-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m31.05,115.61l.82,2.29c.61,2.08,2.11,3.67,2.11,3.67,0,0,1.06.22,2.01-.28l1.2-.89c-.61-.33-4.12-3.04-6.15-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m18.15,90.07s.83,2.07,1.43,3.99l.85,3.5c-.12-.15-.52-1.06-.67-1.24-1.61-3.22-2.54-5.26-3.89-8.92,0,0,1.64,1.96,2.28,2.67Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m10.32,81.82s-4.56-4.81-7.29-15.9H0s.72,12.21,12.37,22.62l-2.05-6.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m3.03,65.93c2.59-10.81,7.29-15.9,7.29-15.9l1.17-3.85C2.86,54.36,1.46,65.93,1.46,65.93c0,0,1.4,11.57,10.03,19.74l-1.17-3.85s-4.7-5.09-7.29-15.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m9.27,80.49s.36,2.19.3,3.18l.74,2.91,2.05,1.97-.88-2.88-1.17-3.85-1.05-1.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "12.37 43.3 11.49 46.18 10.32 50.03 9.27 51.36 9.27 48.53 11.49 44.11 12.37 43.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m127.52,98.93l-1.72,5.03s-.43,1.37.28,2.8l-3.93,4.53.52-6.18,4.85-6.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m121.66,18.03c2.91,9.79,7.21,17.51,7.21,17.51.98,2.17,2.33,5.08,2.33,5.08.57,1.24,1.56,3.84,1.56,3.84-2.82-3.12-4.66-5.85-6.82-8.67-4.17-5.45-7.01-15.06-8.4-20.66-.65-2.63-.99-4.37-.99-4.37-2.42-1.17-3.7-1.9-3.85-1.98-.22-.11-.45-.21-.67-.31.99-1.3,2.2-2.27,2.2-2.27,3.74-.56,5.28,1.48,5.28,1.48.23,1.88.54,3.7.91,5.44.37,1.72.79,3.36,1.26,4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m131.2,40.62s-2.11-4.66-2.25-4.9c0,0-4.38-7.9-7.29-17.69-.46-1.56-.89-3.2-1.26-4.91,0,0-.75,13.06,10.79,27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m117.24,15.89s.45.46,1.8,4.68c0,0-.46-5.89-1.99-10.6,0,0-1.6-2.99-2.85-3.75-.19.16-1.72,1.19-3.97,4.41.22.1.91.64,1.13.75.15.09,2.43,1.73,5.88,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m119.5,7.68s-1.33-1.77-4.52-1.57c1.36,1.86,3.95,2.3,4.52,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m117.24,15.89l-.97-2.77c-1.29-1.73-2.77-2.63-2.77-2.63,0,0-1.31.19-2.57.62l.42.28c3.05,2.01,5.88,4.51,5.88,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m130.48,41.78s-.83-2.07-1.43-3.99l-.85-3.5c.12.15.52,1.06.67,1.24,1.61,3.22,2.54,5.26,3.89,8.92,0,0-1.64-1.96-2.28-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m138.31,50.03s4.56,4.81,7.29,15.9h3.03s-.72-12.21-12.37-22.62l2.05,6.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m121.66,113.82c2.91-9.79,7.21-17.51,7.21-17.51.98-2.17,2.33-5.08,2.33-5.08.57-1.24,1.56-3.84,1.56-3.84-2.82,3.12-4.66,5.85-6.82,8.67-4.17,5.45-7.01,15.06-8.4,20.66-.65,2.63-.99,4.37-.99,4.37-2.42,1.17-3.7,1.9-3.85,1.98-.22.11-.45.21-.67.31.99,1.3,2.2,2.27,2.2,2.27,3.74.56,5.28-1.48,5.28-1.48.23-1.88.54-3.7.91-5.44.37-1.72.79-3.36,1.26-4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m131.2,91.24s-2.11,4.66-2.25,4.9c0,0-4.38,7.9-7.29,17.69-.46,1.56-.89,3.2-1.26,4.91,0,0-.75-13.06,10.79-27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m117.58,115.61s.11-.11,1.46-4.33c0,0-.46,5.89-1.99,10.6,0,0-1.6,2.99-2.85,3.75-.19-.16-3.4-3.02-4.3-4.2.22-.1,1.69-1.17,1.91-1.28.15-.09,2.9-1.86,5.77-4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m119.5,124.17s-1.33,1.77-4.52,1.57c1.36-1.86,3.95-2.3,4.52-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m117.58,115.61l-.82,2.29c-.61,2.08-2.11,3.67-2.11,3.67,0,0-1.06.22-2.01-.28l-1.2-.89c.61-.33,4.12-3.04,6.15-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m130.48,90.07s-.83,2.07-1.43,3.99l-.85,3.5c.12-.15.52-1.06.67-1.24,1.61-3.22,2.54-5.26,3.89-8.92,0,0-1.64,1.96-2.28,2.67Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m138.31,81.82s4.56-4.81,7.29-15.9h3.03s-.72,12.21-12.37,22.62l2.05-6.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m145.6,65.93c-2.59-10.81-7.29-15.9-7.29-15.9l-1.17-3.85c8.63,8.18,10.03,19.74,10.03,19.74,0,0-1.4,11.57-10.03,19.74l1.17-3.85s4.7-5.09,7.29-15.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m139.35,80.49s-.36,2.19-.3,3.18l-.74,2.91-2.05,1.97.88-2.88,1.17-3.85,1.04-1.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "136.25 43.3 137.13 46.18 138.31 50.03 139.35 51.36 139.35 48.53 137.13 44.11 136.25 43.3"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 33.85,
    y: 71.38,
    width: 11.92,
    height: 11.92,
    transform: "translate(-43.03 50.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 46.12,
    y: 82.83,
    width: 2.93,
    height: 2.93,
    transform: "translate(-45.67 58.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 50.26,
    y: 77.38,
    width: 5.73,
    height: 5.73,
    transform: "translate(-41.18 61.07) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 51.84,
    y: 85.64,
    width: 12.98,
    height: 12.98,
    transform: "translate(-48.06 68.23) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 70.79,
    y: 87.26,
    width: 6.09,
    height: 6.09,
    transform: "translate(-42.23 78.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 64.71,
    y: 96.1,
    width: 8.4,
    height: 7.95,
    transform: "translate(-50.58 78.04) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 64.09,
    y: 78.43,
    width: 4.79,
    height: 4.51,
    transform: "translate(-37.58 70.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 67.98,
    y: 105.89,
    width: 13.29,
    height: 12.51,
    transform: "translate(-57.44 85.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 80.02,
    y: 99.36,
    width: 4.14,
    height: 3.9,
    transform: "translate(-47.59 87.72) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 85.81,
    y: 89.42,
    width: 12.28,
    height: 11.57,
    transform: "translate(-40.38 92.9) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 98.65,
    y: 83.6,
    width: 5.61,
    height: 5.28,
    transform: "translate(-31.27 97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 102.62,
    y: 75.87,
    width: 4.21,
    height: 3.96,
    transform: "translate(-24.37 96.85) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 79.53,
    y: 81.21,
    width: 8.33,
    height: 7.84,
    transform: "translate(-35.69 84.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m74.77,11.16l-53.4,53.4,9.49,9.49,8.74-8.74,8.61,8.61,2.89-2.89,7.13,7.13,5.67-5.67,1.83,1.83,1.33-1.33,8.41,8.41,7.29-7.29,1.1,1.1,6.45-6.45,1.5,1.5-7.14,7.14,8.1,8.1,8.79-8.79-6.83-6.83,1.36-1.36,5.47,5.47,2.05-2.05,6.39,6.39,6.36-6.36,2.6,2.6,9.96-9.96L74.77,11.16Zm40.92,52.98h-17.18l-23.39-22.83-18.52,18.08h23.93l-5.41-5.28-2.86,2.78h-8.32l7.02-6.83,4.16-4.06,4.16,4.06,9.56,9.33,4.87,4.75h-50.4l27.6-26.94,4.21-4.11,4.21,4.11,22.73,22.19h5.56l-25.51-24.9-4.21-4.11-2.78-2.72-2.78,2.72-4.21,4.11-30.38,29.65h-8.42L63.91,30.38l4.21-4.11,2.78-2.72,4.21-4.11,4.21,4.11,2.78,2.72,4.21,4.11,34.59,33.76h-5.23Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdamantineRock);
export default __webpack_public_path__ + "static/media/adamantine-rock.efc3a4329572b180b445eb67d03e63c2.svg";
export { ForwardRef as ReactComponent };